import React, { useEffect, useState } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import Button from '@nubank/nuds-web/components/Button/Button';
import { createPortal } from 'react-dom';

import SearchQuestionModal from '../SearchQuestionModal/SearchQuestionModal';

const StyledTypography = styled(Typography)`
  background: linear-gradient(87deg, #9F2DEB 0%, #6200A3 100%);
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  height: 100%;
`;

const StyledButton = styled(Button)`
  width: 280px;
  font-family: Graphik-Medium,Graphik-Regular,'Gotham SSm A','Gotham SSm B','Helvetica Neue',Helvetica,Arial,sans-serif;
  
  span {
    margin: 0 auto;
    text-align: center;
  }
`;

export default function Search() {
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [isOpen]);

  return (
    <Box
      tag="section"
      id="search-section"
      width="100%"
      height="100%"
      marginVertical={{ xs: '120px', lg: '140px' }}
      paddingHorizontal={{ xs: '1.5rem', md: '3.5rem' }}
    >
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginBottom="24px"
      >
        <Typography variant="heading2" marginRight="8px">
          ¿Necesitas
        </Typography>
        <StyledTypography tag="span" variant="heading2">
          ayuda
        </StyledTypography>
        <Typography variant="heading2">
          ?
        </Typography>
      </Box>

      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        margin="0 auto"
      >
        <StyledButton onClick={() => setIsOpen(true)}>
          Busca tus preguntas aquí
        </StyledButton>
      </Box>

      {isOpen && createPortal(
        <SearchQuestionModal
          closeModal={closeModal}
        />, document.getElementById('modal-root'),
      )}

    </Box>
  );
}
